export enum Role {
  Admin = 'Admin',
  Normal = 'Normal',
}
